import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Card } from './ui/card';
import { Stethoscope, Activity, Briefcase, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const categories = [
  {
    icon: Stethoscope,
    title: 'Nursing Professionals',
    description:
      'From experienced RNs to compassionate CNAs, we connect healthcare facilities with highly qualified nursing talent. Whether you need travel nurses, per diem support, or long-term direct hires, our vetted professionals are ready to deliver exceptional patient care across various settings.',
  },
  {
    icon: Activity,
    title: 'Allied Health Experts',
    description:
      'We provide certified specialists in radiology, therapy, laboratory services, and more. Our allied health professionals play a vital role in diagnostics, treatment, and rehabilitation — helping your teams maintain top-tier outcomes and operational efficiency.',
  },
  {
    icon: Briefcase,
    title: 'Non-Clinical Staffing',
    description:
      'Behind every great healthcare team is a strong support system. We supply skilled administrative staff, medical billers, IT personnel, and operational support professionals to keep your facility running smoothly — from the front desk to the back office.',
  },
];

export const StaffingCategories = () => {
  const [titleRef, titleVisible] = useScrollAnimation();
  const [cardsRef, cardsVisible] = useScrollAnimation();

  return (
    <section
      id="staffing"
      data-testid="staffing-section"
      className="section-padding bg-white"
    >
      <div className="container-width">
        {/* Section Header */}
        <div
          ref={titleRef}
          className={`text-center mb-16 animate-on-scroll ${titleVisible ? 'visible' : ''}`}
        >
          <span className="inline-block text-sm font-medium tracking-widest uppercase text-primary/60 mb-4">
            Who We Place
          </span>
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-primary">
            Core Staffing Categories
          </h2>
        </div>

        {/* Category Cards */}
        <div
          ref={cardsRef}
          className={`grid md:grid-cols-3 gap-8 stagger-children ${cardsVisible ? 'visible' : ''}`}
        >
          {categories.map((category, index) => (
            <Link
              key={index}
              to="/find-talent"
              className="block"
              data-testid={`category-link-${index}`}
            >
              <Card
                className="group p-8 rounded-2xl border-border/50 bg-white card-hover cursor-pointer h-full"
                data-testid={`category-card-${index}`}
              >
                <div className="icon-container mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                  <category.icon className="h-6 w-6" />
                </div>
                <h3 className="text-2xl font-semibold text-primary mb-4">
                  {category.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed mb-6">
                  {category.description}
                </p>
                <div className="flex items-center text-primary font-medium group-hover:gap-3 gap-2 transition-all duration-300">
                  <span>Learn More</span>
                  <ArrowRight className="h-4 w-4" />
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StaffingCategories;
